const masterchefv1 = require("./masterchef_v1");
const masterchefv2 = require("./masterchef_v2");

module.exports = {
  UNIV2_ROUTER_ADDRESS: "0xd9e1ce17f2641f24ae83637ab66a2cca9c378b9f",
  FARMS: {
    masterchefv1,
    masterchefv2
  },
};
